const TransactionStatus = {
    0: "Created",
    1: "Succeeded",
    2: "Failed",
};

export default TransactionStatus;
